import React from 'react';
import { Linkedin, Instagram } from 'lucide-react';
import { companyInfo, socialLinks } from '../data/mock';

const iconMap = {
  linkedin: Linkedin,
  instagram: Instagram
};

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-6xl mx-auto px-6">
        {/* Main Footer */}
        <div className="py-12 grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Company Info */}
          <div>
            <h3 className="font-semibold text-base mb-4">
              {companyInfo.name}
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed">
              Construction métallique, serrurerie et installations solaires en Suisse romande.
            </p>
          </div>

          {/* Address */}
          <div>
            <h4 className="font-medium text-sm mb-4">Adresse</h4>
            <p className="text-gray-400 text-sm leading-relaxed">
              {companyInfo.address.street}<br />
              {companyInfo.address.postalCode} {companyInfo.address.city}<br />
              {companyInfo.address.country}
            </p>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-medium text-sm mb-4">Contact</h4>
            <div className="text-gray-400 text-sm leading-relaxed space-y-2">
              {companyInfo.phone.map((contact, index) => (
                <div key={index}>
                  <a 
                    href={`tel:${contact.number.replace(/\s/g, '')}`}
                    className="hover:text-white transition-colors"
                  >
                    {contact.number}
                  </a>
                  <span className="text-gray-500 ml-1 text-xs">
                    – {contact.name}
                  </span>
                </div>
              ))}
              <a 
                href={`mailto:${companyInfo.email}`}
                className="block hover:text-white transition-colors mt-3"
              >
                {companyInfo.email}
              </a>
            </div>
            
            {/* Social Links with Icons */}
            <div className="flex items-center gap-4 mt-6">
              {socialLinks.map((social) => {
                const IconComponent = iconMap[social.icon];
                return (
                  <a
                    key={social.name}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-9 h-9 flex items-center justify-center border border-gray-700 text-gray-400 hover:text-white hover:border-gray-500 transition-colors"
                    aria-label={social.name}
                  >
                    <IconComponent size={16} />
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-gray-800 text-center">
          <p className="text-gray-500 text-sm">
            © {currentYear} {companyInfo.name}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
